import { useState } from 'react';
import PropTypes from 'prop-types';

const Tooltip = ({ children, text, isDarkMode, direction = 'above' }) => {
  const [show, setShow] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    if (direction === 'right') {
      setPosition({ top: rect.top + rect.height / 2, left: rect.right + 8 });
    } else {
      setPosition({ top: rect.top - 8, left: rect.left + rect.width / 2 });
    }
    setShow(true);
  };

  return (
    <div
      className="relative inline-block overflow-visible"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setShow(false)}
      onClick={() => setShow(false)}
    >
      {children}
      {show && (
        <div
          className={`fixed px-2 py-1 text-xs font-medium whitespace-nowrap rounded pointer-events-none z-[9999] bg-fg text-fg-inverse shadow-md ${
            direction === 'right'
              ? 'transform -translate-y-1/2 transition-opacity duration-150'
              : 'transform -translate-x-1/2 -translate-y-full'
          }`}
          style={{ top: `${position.top}px`, left: `${position.left}px` }}
        >
          {text}
          {direction === 'right' ? (
            <div className="absolute top-1/2 right-full transform -translate-y-1/2 w-0 h-0 border-4 border-transparent border-r-fg" />
          ) : (
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-4 border-transparent border-t-fg" />
          )}
        </div>
      )}
    </div>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  isDarkMode: PropTypes.bool, // kept for caller compat; no longer used for color (tokens are theme-driven)
  direction: PropTypes.oneOf(['above', 'right']),
};

export default Tooltip;
